// Branch-scoped permission fetch.
//
// GET `${CUSTOMER_URL}/guardian-users/permission`
// Headers (supplied by the apiClient interceptor unless overridden here):
//   - Authorization: <accessToken> — raw JWT, no `Bearer ` prefix
//   - Platform: MDG_GUARDIAN
//   - branch-id: <branch id>
//
// Response body:
//   {
//     status: { message, status_code, success },
//     data: {
//       type: 'COMPANY',
//       permissions: [{ id, companyId, branchId, moduleId, permission, moduleName, moduleSlug }],
//     },
//   }
//
// The `branch-id` header is passed per-request so the caller can fetch the
// permissions of a branch it has not switched to yet — the interceptor
// would otherwise stamp the *currently selected* branch onto the request.

import { apiClient } from './client'

import APIs from './index'

/**
 * Fetch the permission payload for a single branch.
 *
 * @param {object} [opts]
 * @param {string|number} [opts.branchId] Numeric branch id (preferred).
 * @param {string} [opts.branchUuid] Fallback when the branch has no numeric id.
 * @returns {Promise<{ type: string, permissions: Array } | null>} The `data`
 *   payload, or `null` when the request failed / returned no payload.
 */
export const getGuardianPermissionsApi = async ({ branchId, branchUuid } = {}) => {
  const headers = {}
  if (branchId !== undefined && branchId !== null && branchId !== '') {
    headers['branch-id'] = String(branchId)
  } else if (branchUuid) {
    headers['branch-id'] = String(branchUuid)
  }

  try {
    const res = await apiClient.get(APIs.GUARDIAN_USERS.permission, {
      headers,
      // `silentError` skips the apiClient's global 500 popup — the caller
      // surfaces its own message and blocks the branch switch.
      silentError: true,
    })
    const payload = res?.data?.data
    return payload && typeof payload === 'object' ? payload : null
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[getGuardianPermissionsApi] failed to load branch permissions', err)
    return null
  }
}
